export default __webpack_public_path__ + "static/media/023-speed limit.aed48e6f.png";